import { render, staticRenderFns } from "./pmlbform.vue?vue&type=template&id=68fa70c2&scoped=true"
import script from "./pmlbform.vue?vue&type=script&lang=js"
export * from "./pmlbform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa70c2",
  null
  
)

export default component.exports